import React, { useEffect, useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import SwiperCore from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';
import { SOURCE_URL } from '../../../config';
import language from '../../../utils/LanguageSettings';
import { useAppDispatch, useAppSelector } from '../../../stores/hook';
import { setSwiperAutoPlay, setTncShow, setTncText, setVideoShow, setVideoUrl } from '../GetStarted/GetStartedSlice';
import BusinessBannerText from './BusinessBannerText';
import { ImageHeightSetterForBusinessPage } from '../../functions/ResetHeight';


interface BusinessBannerProps {
    element: any[];
}

SwiperCore.use([Autoplay, Pagination]);

const BusinessBanner: React.FC<BusinessBannerProps> = ({ element }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const swiperRef = useRef(null);
  const autoplayRef = useRef(null);
  const swiperAutoPlay = useAppSelector((state) => state.getStarted.swiperAutoPlay);
  const dispatch = useAppDispatch();

  useEffect(()=>{
    if (!swiperRef.current) return;
    const swiperInstance = swiperRef.current.swiper;
    if(swiperAutoPlay){
      swiperInstance.autoplay.start();
    }else{
      swiperInstance.autoplay.stop();
    }
  },[swiperAutoPlay])

  const clickTnc = (tncText: any) => {
    dispatch(setSwiperAutoPlay(false));
    dispatch(setTncShow(true));
    dispatch(setTncText(tncText));
  }

  const handleSlideChange = (swiper) => {
    setCurrentSlide(swiper.realIndex)
    ImageHeightSetterForBusinessPage();
    if(document.getElementsByTagName("iframe")[0] != null){
      const iframeSrc = document.getElementsByTagName("iframe")[0].src;
      document.getElementsByTagName("iframe")[0].src = '';
      document.getElementsByTagName("iframe")[0].src = iframeSrc;
    }
  };

  useEffect(()=> {
      ImageHeightSetterForBusinessPage();
  },[element,language]);

  useEffect(() => {
      window.addEventListener('resize', ImageHeightSetterForBusinessPage);
      return () => {
        window.removeEventListener('resize', ImageHeightSetterForBusinessPage);
      };
    }, []);

  return (
    <ul className="carousel-container slides" style={{height:"100%",padding:"0"}}>
      <style>{`.carousel-container .swiper-pagination-bullet{background: transparent;position: relative;border: 2px solid #fff;width: 8px;height: 8px;opacity: 1;margin: 0 6px!important;} .carousel-container .swiper-pagination-bullet-active{border-color: #ef9528;} .carousel-container li{width: 100%;float: left;margin-right: -100%;position: relative;opacity: 1;display: block;z-index: 2;height: 100%;}`}</style>
      <style>{`.swiper-pagination{width: 350px !important;margin: 0 auto !important;position: relative !important;bottom: 25px !important;} #sliding-banner .arrowed-link:hover,#sliding-banner .arrowed-link{color: #fff !important;} a {;text-decoration: none;}`}</style>
      <Swiper
        ref={swiperRef}
        modules={[Autoplay, Pagination]}
        pagination={{
          clickable: true,
          bulletClass: 'swiper-pagination-bullet',
          bulletActiveClass: 'swiper-pagination-bullet-active'
        }}
        autoplay={{
          delay: element[0]?.IntervalTime * 1000 || 5000,
          disableOnInteraction: false,
          waitForTransition: true,
          pauseOnMouseEnter:true,
          ref: (el) => (autoplayRef.current = el),
        }}
        loop={true}
        slidesPerView={1}
        className="custom-swiper"
        speed={500}
        noSwiping={true}
        onSlideChange={handleSlideChange}
        style={{height: "100%"}}
      >
        {Array.isArray(element) && element.map((item, index) => (
          <SwiperSlide key={index}  data-swiper-autoplay={item.IntervalTime * 1000}>
            <li key={index} id={"slide-"+index} data-interval={item.IntervalTime}  className={"object-item "+item?.TextColor?.toLowerCase()} data-imgposition={item?.BannerImagePosition?.replace(" - ", " ").toLowerCase()} data-imgpositiontab={item?.BannerImagePositionTab?.replace(" - ", " ").toLowerCase()} data-imgpositionmob={item?.BannerImagePositionMob?.replace(" - ", " ").toLowerCase()}>
                <img src={SOURCE_URL + item?.BannerImage?.data?.attributes?.url} className='lazy object-desktop-image w-100 main-img img-fit d-xl-block d-none lazyloaded' style={{objectPosition: item?.BannerImagePosition?.replace(" - ", " ").toLowerCase()}}/>
				        <img src={SOURCE_URL + item?.BannerImageTab?.data?.attributes?.url} className='lazy object-tab-image w-100 main-img img-fit d-xl-none d-lg-block d-none lazyloaded' style={{objectPosition: item?.BannerImagePositionTab?.replace(" - ", " ").toLowerCase()}}/>
				        <img src={SOURCE_URL + item?.BannerImageMob?.data?.attributes?.url} className='lazy object-mobile-image w-100 main-img img-fit d-lg-none d-block lazyloaded' style={{objectPosition: item?.BannerImagePositionMob?.replace(" - ", " ").toLowerCase()}}/>
                {(item?.BannerText || item?.Button?.URL) ?
                <div className={"caption-text py-5 "+item?.BannerTextPosition?.toLowerCase()+" "+item?.BannerTextVerticalAlignment?.toLowerCase()+" "+item?.TextColor?.toLowerCase()+" pxc"}>
                    <div>
                        <div className="to-be-calculated swiper-no-swiping">
                            <style>{`#sliding-banner li#slide-${index} .title-art {width: ${item?.WidthDesktop};height: ${item?.HeightDesktop};max-width:${item?.MaxWidthDesktop};max-height:${item?.MaxHeightDesktop};}@media(max-width: 991px){ #sliding-banner li#slide-${index} .title-art{width: ${item?.WidthMobile};height:${item?.HeightMobile};max-width: ${item?.MaxWidthMobile};max-height:${item?.MaxHeightMobile}}}`}</style>
                            <BusinessBannerText bannerText={item?.BannerText} lang={language} currentSlide={currentSlide}/>
                            {item?.TcText ? 
                            <>
                            <div className='clearfix'></div>
                            <a href='javascript:void(0);' data-src={'#tc-'+index} data-text={(language == 'en' ? "See Terms & Conditions" : "條款細則") +' >> '} className='arrowed-link text-14 mt-3' style={{cursor:"pointer"}} onClick={() => clickTnc(item?.TcText)}>
                                {language == 'en' ? "See Terms & Conditions" : "條款細則"}
                                <i className='icon-angle-right'></i>
                            </a>
                            </>
                            :<></>}
                            
                            {item?.Button?.URL ? 
                            <>
                                <div className='clearfix'></div>
                                <a href={item?.Button?.URL} target={item?.Button?.OpenLinkInANewTab ? '_blank' : '_self'} className='default-btn mt-4' id={item?.ButtonID}>{item?.Button?.LinkText}</a>
                            </>
                            :<></>}
                        </div>
                    </div>
                </div>
                :<></>}
                {item?.BackgroundColorMobile != "" ?
                <style>{`@media(max-width: 991px){ #sliding-banner li#slide-${index} .caption-text:before{content:'';background-color:${item?.BackgroundColorMobile};width:100%;height:100%;top:50%;left:0;position:absolute;z-index:-1;}#sliding-banner li#slide-${index} .caption-text{background: linear-gradient(180deg, transparent 0%, ${item?.BackgroundColorMobile} 15%, ${item?.BackgroundColorMobile} 20%, ${item?.BackgroundColorMobile} 40%, ${item?.BackgroundColorMobile} 100%) !important;}}`}</style>
                :<></>
                }
            </li>
          </SwiperSlide>
        ))}
      </Swiper>
    </ul>
  );
};

export default BusinessBanner;